import { PropsWithChildren, useMemo } from 'react';

import { rem, Box, SystemStyleObject } from '@vimeo/bokeh';

export function IconNotification({
  children,
  isVisible,
}: PropsWithChildren<{ isVisible: boolean }>) {
  const style: SystemStyleObject = useMemo(
    () => ({
      '&::after': {
        content: '""',
        position: 'absolute',
        top: rem(-4),
        right: rem(-4),
        width: rem(8),
        height: rem(8),
        borderRadius: rem(4),
        background: 'red.500',
        display: isVisible ? 'block' : 'none',
      },
    }),
    [isVisible],
  );

  return (
    <Box position={'relative'} width={rem(24)} height={rem(24)} sx={style}>
      {children}
    </Box>
  );
}
